import styled from 'styled-components'

export const LoadingContainer = styled.div`
  & * {
    color: #333;
  }
`
